namespace Nobox.Nobox.BodyType {
    export enum BodyTypeEnum {
        Text = 0,
        HTML = 1,
        QuickReply = 2,
        CallToAction = 3,
        List = 4
    }
    Serenity.Decorators.registerEnumType(BodyTypeEnum, 'Nobox.Nobox.BodyType.BodyTypeEnum', 'Nobox.BodyTypeEnum');
}
